<!--
 * @Author: gaoxueting
 * @Date: 2020-06-19 19:23:37
 * @LastEditTime: 2021-09-01 11:43:21
 * @LastEditors: Please set LastEditors
 * @Description:
-->
<template>
    <Modal v-model="modal"
           :mask-closable="false"
           :title="$t('绑定服务器')"
           @on-cancel="cancel"
           width=800
           class="add-network">
        <Form ref="createRdsForm"
              :model="formData"
              class="form"
              :rules="rules"
              :label-width="90">
            <FormItem :label="`${$t('选择服务器')}:`">
                <div style="margin:-10px 0 0 1px;"
                     class="bindHostTable">
                    <rcTable ref="selection"
                             :tableAttr="tableAttr"
                             @onSelectChange="onSelectChange"></rcTable>
                </div>
            </FormItem>
            <FormItem :label="`${$t('选择网卡')}:`"
                      prop="engine">
                <Select v-model="formData.netCard"
                        style="width:300px;"
                        @on-change="change">
                    <Option v-for="item in this.choosed.ports"
                            :key="item.id"
                            :value="item.id">IP：{{item.fixedIp}}，MAC：{{item.macAddress}}</Option>
                </Select>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button @click="cancel"
                    class="ivu-btn-text">{{$t('取消')}}</Button>
            <Button type="primary"
                    @click="save"
                    :loading="loading">
                <span v-show="!loading">&nbsp;{{$t('确认')}}&nbsp;</span>
                <span v-show="loading">&nbsp;{{$t('确认中')}}&nbsp;</span>
            </Button>
        </div>

    </Modal>
</template>

<script>
import API from '@/service/api.js'
import rcTable from '@c/basic/rcTable'
import { isNullOrEmpty } from '@/service/utils.js'
export default {
    name: 'createvirip',
    props: [],
    components: {
        rcTable
    },
    data () {
        return {
            modal: false,
            loading: false,
            envId: this.$route.query.envId,
            choosed: {
                ports: [{
                    id: '',
                    fixedIp: '',
                    macAddress: ''
                }]
            },
            rules: {},
            rowData: null,
            formData: {
                netCard: null
            },
            netCardList: [],
            tableAttr: {
                source: {
                    type: 'staticData',
                    tableData: {
                        totalRows: 0,
                        dataList: []
                    }
                },
                height: 200,
                pageData: {
                    show: false
                },
                // isSingleSelect: true,
                columns: [
                    {
                        title: '',
                        key: 'id',
                        width: 50,
                        render: (h, params) => {
                            const id = params.row.id
                            const choosedId = this.choosed.id
                            let flag = false
                            if (choosedId === id) {
                                flag = true
                            } else {
                                flag = false
                            }
                            const self = this
                            return h('div', [
                                h('Radio', {
                                    props: {
                                        value: flag,
                                        disabled: isNullOrEmpty(params.row.ports)
                                    },
                                    on: {
                                        'on-change': () => {
                                            self.onSelectChange(params.row)
                                        }
                                    }
                                })
                            ])
                        }
                    },
                    {
                        title: this.$t('名称'),
                        render: (h, params) => {
                            return h('div', [
                                h('p', params.row.instanceName)
                            ])
                        }
                    },
                    {
                        title: this.$t('类型'),
                        render: (h, params) => {
                            return h('div', [
                                h('p', params.row.serverType === 'instance' ? '实例' : '')
                            ])
                        }
                    },
                    {
                        title: this.$t('状态'),
                        render: (h, params) => {
                            return h('statusview', {
                                props: {
                                    state: params.row.status.toLowerCase(),
                                    stateName: this.$i18n.t(params.row.statusName)
                                }
                            })
                        }
                    },
                    {
                        title: this.$t('主网卡IP地址'),
                        width: 150,
                        render: (h, params) => {
                            const txt = params.row.innerIp
                            return h('div', [
                                h('p', txt)
                            ])
                        }
                    },
                    {
                        title: this.$t('扩展网卡IP地址'),
                        width: 180,
                        render: (h, params) => {
                            const txt = params.row.secondaryIP
                            return h('div', [
                                h('p', txt)
                            ])
                        }
                    }
                ]
            },
            statusList: {

            }
        }
    },
    methods: {
        onSelectChange (rows) {
            this.choosed = rows
            this.formData.netCard = this.choosed.ports && this.choosed.ports[0].id
            this.getPortList()
        },
        // 打开弹出框
        openModal (row) {
            this.modal = true
            this.rowData = row
            this.axios.get(this.urlFormat(API.PORTS_BIND_SERVERLIST, false), {
                params: {
                    cloudEnvId: this.envId,
                    portId: row.id
                }
            }).then(res => {
                this.modal = true
                this.tableAttr.source.tableData.totalRows = res.length
                this.tableAttr.source.tableData.dataList = res
                this.$refs.selection.init()
                this.choosed = this.tableAttr.source.tableData.dataList.length !== 0 ? this.tableAttr.source.tableData.dataList[0] : []
                this.formData.netCard = this.choosed.length !== 0 ? this.choosed.ports[0].id : ''
                this.getPortList()
            })
        },
        getPortList () {
            this.axios.get(this.urlFormat(API.PORTS_INSTANCE_PORT, false), {
                params: {
                    cloudEnvId: this.envId,
                    device: this.choosed.id
                }
            }).then(res => {
                this.netCardList = res
                this.formData.netCard = this.netCardList.length !== 0 ? this.netCardList[0].id : ''
            })
        },
        change () {

        },
        // 取消
        cancel () {
            this.modal = false
        },
        // 表单提交
        save () {
            const params = {
                portId: this.rowData.id,
                vmPortId: this.formData.netCard
            }
            this.axios.post(this.urlFormat(API.POST_ATTACH_SERVER, false), params).then(res => {
                if (res.status) {
                    this.cancel()
                    this.$emit('refresh')
                }
                this.loading = false
            }).catch(e => {
                this.loading = false
            })
        }
    }
}
</script>
<style lang="less">
.bindHostTable .ivu-table-border td {
    border-left: 1px solid #e8eaec;
}
</style>
